import { type CarFeature } from '@prisma/client'
import { Icon } from '#app/shared/ui/icons/Icon.js'

interface AccordionSlidesProps {
  features: CarFeature[]
  category: string
}

export default function AccordionSlides({
  features,
  category,
}: AccordionSlidesProps) {
  const categoryFeatures = features.filter(
    (feature) => feature.category === category && feature.isActive,
  )

  return (
    <div className="flex flex-col gap-[6px]">
      {categoryFeatures.map((feature) => (
        <div
          key={feature.id}
          className={`
            ml-7 mr-7 flex items-center gap-2 rounded-base border
            border-neutral-100 bg-neutral-25 py-2 pl-4
          `}
        >
          <Icon size="8px" name="basic/check" className="text-primary-500" />
          <p className="text-base-medium text-neutral-900">{feature.name}</p>
        </div>
      ))}
    </div>
  )
}
